(function () {
  "use strict";

  var MATCH_ATTRIBUTES = [
    ["shapeGroupKey", "Kształt"],
    ["sizeCode", "Rozmiar"],
    ["frameCode", "Rama"],
    ["ledCode", "Funkcje LED"],
    ["featuresCode", "Funkcje"],
    ["reserveCode", "Sposób mocowania"],
  ];
  var VISIBLE_ATTRIBUTES = MATCH_ATTRIBUTES.filter(function (pair) {
    return pair[0] !== "shapeGroupKey";
  });
  var HIDDEN_SELECTORS = [
    "variant-radios",
    "variant-selects",
    "product-variant-picker",
    ".product-form__input",
    ".product-form__variants",
    ".selector-wrapper",
    ".product__variants",
    ".product-variant-selector",
    ".variant-picker",
    ".variant-selects",
    ".product-options",
    "[data-product-variants]",
    "[data-variant-picker]",
    "select[name='id']",
    "form[action*='/cart/add']:not([data-standard-form])",
    ".shopify-payment-button",
    ".product-form__buttons",
    ".product-form__submit",
  ].join(",");

  function parseJson(value, fallback) {
    try {
      var parsed = JSON.parse(value || "");
      return Array.isArray(parsed) ? parsed : fallback;
    } catch (_error) {
      return fallback;
    }
  }

  function parseJsonObject(value) {
    try {
      var parsed = JSON.parse(value || "");
      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
    } catch (_error) {
      return {};
    }
  }

  function money(value, currency) {
    var amount = Number(value);
    if (!Number.isFinite(amount)) return "";
    try {
      return new Intl.NumberFormat("pl-PL", { style: "currency", currency: currency || "PLN" }).format(amount);
    } catch (_error) {
      return amount.toFixed(2) + " " + (currency || "PLN");
    }
  }

  function normalizeShape(shape) {
    if (shape === "PRHXX" || shape === "PRVXX") return "PR";
    if (shape === "PRRXX") return "PRR";
    if (shape === "KLXXX") return "OK";
    if (shape === "CH01V" || shape === "CH01H") return "CH01";
    if (shape === "DZ2VX") return "DZ2";
    return String(shape || "").replace(/X+$/g, "");
  }

  function enrich(item, root) {
    var sku = String(item.sku32 || "").toUpperCase();
    var shape = sku.slice(4, 9);
    var size = sku.slice(9, 15);
    var width = Number(size.slice(0, 3));
    var height = Number(size.slice(3, 6));
    var frame = item.frameCode || sku.slice(15, 20);
    var led = item.ledCode || sku.slice(20, 25);
    var features = item.featuresCode || sku.slice(25, 29);
    var reserve = item.reserveCode || sku.slice(29, 32);
    var shapeGroup = item.shapeGroupKey || normalizeShape(shape) || (root.dataset.groupKey || "").split(":").pop() || "";
    var next = Object.assign({}, item, {
      sku32: sku,
      shapeGroupKey: shapeGroup,
      glassCode: item.glassCode || sku.slice(0, 2),
      originCode: item.originCode || sku.slice(2, 4),
      orientation: item.orientation || shape.slice(2, 3),
      sizeCode: item.sizeCode || (width && height ? width + "x" + height : size),
      frameCode: frame,
      ledCode: led,
      featuresCode: features,
      reserveCode: reserve,
      widthCm: item.widthCm || width,
      heightCm: item.heightCm || height,
      configuratorGroupKey: item.configuratorGroupKey || root.dataset.groupKey || "standard:" + shapeGroup,
      productGroupKey: item.productGroupKey || item.configuratorGroupKey || root.dataset.groupKey || "standard:" + shapeGroup,
    });
    next.labels = {
      shapeGroupKey: shapeGroup === "PR" ? "Prostokąt" : shapeGroup === "OK" ? "Okrągłe" : shapeGroup,
      glassCode: next.glassCode === "4O" ? "Optiwhite 4 mm" : next.glassCode === "4S" ? "Standard 4 mm" : next.glassCode === "3S" ? "Standard 3 mm" : next.glassCode,
      sizeCode: next.widthCm && next.heightCm ? next.widthCm + "x" + next.heightCm + " cm" : next.sizeCode,
      frameCode: next.frameCode === "BRXXX" ? "Bez ramy"
        : next.frameCode === "ALSBK" || next.frameCode === "ALXBK" ? "Rama aluminiowa czarna"
        : next.frameCode === "ALSGD" ? "Rama aluminiowa złota"
        : next.frameCode === "ALSWE" ? "Rama aluminiowa biała"
        : next.frameCode === "ALSSR" ? "Rama aluminiowa srebrna"
        : next.frameCode === "ALSPK" ? "Rama aluminiowa różowe złoto"
        : next.frameCode === "LOXBK" ? "Rama loft czarna"
        : next.frameCode === "LOXWE" ? "Rama loft biała"
        : next.frameCode,
      ledCode: ledLabel(next.ledCode),
      featuresCode: next.featuresCode === "BRKX" || next.featuresCode === "BRK"
        ? "Brak"
        : [next.featuresCode.indexOf("A") >= 0 ? "Antypara" : "", next.featuresCode.indexOf("Z") >= 0 ? "Zegar" : ""].filter(Boolean).join(" + ") || next.featuresCode,
      reserveCode: reserveLabel(next.reserveCode),
    };
    return next;
  }

  function unique(values) {
    return Array.from(new Set(values.filter(Boolean).map(String))).sort();
  }

  function sizeSortValue(value) {
    var parts = String(value || "").match(/\d+/g) || [];
    var width = Number(parts[0] || 0);
    var height = Number(parts[1] || width || 0);
    return width * 10000 + height;
  }

  function numericCm(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function formatCm(value) {
    var number = numericCm(value);
    if (!number) return "";
    if (Math.round(number) === number) return String(Math.round(number));
    return number.toLocaleString("pl-PL", { maximumFractionDigits: 1 });
  }

  function closestValueIndex(values, selectedValue) {
    if (!values.length) return 0;
    var selected = numericCm(selectedValue);
    var exact = values.findIndex(function (value) {
      return numericCm(value) === selected;
    });
    if (exact >= 0) return exact;
    var closest = 0;
    values.forEach(function (value, currentIndex) {
      if (Math.abs(numericCm(value) - selected) < Math.abs(numericCm(values[closest]) - selected)) closest = currentIndex;
    });
    return closest;
  }

  function uniqueAttributeValues(attribute, values) {
    var result = Array.from(new Set(values.filter(Boolean).map(String)));
    if (attribute === "sizeCode") {
      return result.sort(function (left, right) {
        return sizeSortValue(left) - sizeSortValue(right) || left.localeCompare(right);
      });
    }
    if (attribute === "frameCode") {
      return result.sort(function (left, right) {
        return frameSwatchOrder(left) - frameSwatchOrder(right) || left.localeCompare(right);
      });
    }
    if (attribute === "ledCode") {
      return result.sort(function (left, right) {
        return ledOrder(left) - ledOrder(right) || left.localeCompare(right);
      });
    }
    return result.sort();
  }

  function ledKind(code) {
    var normalized = String(code || "").toUpperCase();
    var trimmed = normalized.replace(/X+$/g, "");
    if (!trimmed || trimmed === "N" || trimmed === "NN" || normalized.indexOf("NN") === 0) return "none";
    if (normalized.indexOf("LT") === 0 || normalized.charAt(1) === "T") return "touch";
    if (normalized.indexOf("LW") === 0 || normalized.charAt(1) === "W") return "switch";
    if (normalized.indexOf("LM") === 0 || normalized.charAt(1) === "M") return "motion";
    return "led";
  }

  function ledOrder(code) {
    var order = {
      touch: 10,
      switch: 20,
      motion: 30,
      led: 40,
      none: 90,
    };
    return order[ledKind(code)] || 99;
  }

  function ledLabel(code) {
    var kind = ledKind(code);
    if (kind === "touch") return "Sterowanie dotykowe";
    if (kind === "switch") return "Sterowanie włącznikiem";
    if (kind === "motion") return "Sterowanie czujnikiem ruchu";
    if (kind === "none") return "Brak LED";
    return "Podświetlenie LED";
  }

  function ledDescription(code) {
    var kind = ledKind(code);
    if (kind === "touch") return "Lustro posiada widoczny przycisk w kształcie podświetlonego pierścienia.";
    if (kind === "switch") return "Lustro ma możliwość sterowania za pomocą standardowego włącznika ściennego.";
    if (kind === "motion") return "Lustro ma możliwość sterowania za pomocą czujnika ruchu.";
    if (kind === "none") return "Lustro nie posiada podświetlenia.";
    return "Lustro posiada podświetlenie LED.";
  }

  function ledIconClass(code) {
    return "ad-mirror-standard__led-option-icon ad-mirror-standard__led-option-icon--" + ledKind(code);
  }

  function ledIconUrl(root, code) {
    var kind = ledKind(code);
    if (!root || !root.dataset) return "";
    if (kind === "touch") return root.dataset.ledIconTouch || "";
    if (kind === "switch") return root.dataset.ledIconSwitch || "";
    if (kind === "none") return root.dataset.ledIconNone || "";
    if (kind === "motion") return root.dataset.ledIconMotion || root.dataset.ledIconSwitch || "";
    return root.dataset.ledIconLed || root.dataset.ledIconSwitch || root.dataset.ledIconTouch || "";
  }

  function canonicalReserveCode(code) {
    var normalized = String(code || "").toUpperCase();
    return normalized === "M00" || normalized === "MKL" || normalized === "MZK" ? normalized : "MKL";
  }

  function reserveIconUrl(root, code) {
    var normalized = canonicalReserveCode(code);
    if (!root || !root.dataset) return "";
    if (normalized === "M00") return root.dataset.mountIconM00 || "";
    if (normalized === "MKL") return root.dataset.mountIconMkl || "";
    if (normalized === "MZK") return root.dataset.mountIconMzk || "";
    return root.dataset.mountIconDefault || "";
  }

  function reserveLabel(code) {
    var normalized = canonicalReserveCode(code);
    if (normalized === "M00") return "Bez mocowania";
    if (normalized === "MKL") return "Zawieszki z kołkami";
    if (normalized === "MZK") return "Klej";
    return "Zawieszki z kołkami";
  }

  function reserveDescription(code) {
    var normalized = canonicalReserveCode(code);
    if (normalized === "M00") return "Bez dodatkowych mocowań w zestawie.";
    if (normalized === "MKL") return "Zawieszki do montażu mechanicznego na ścianie są już przyklejone do lustra. Zestaw zawiera również kołki.";
    if (normalized === "MZK") return "Montaż na klej do luster. Klej znajduje się w zestawie.";
    return "Wybrany sposób mocowania.";
  }

  function frameSwatchKind(code) {
    var normalized = String(code || "").toUpperCase();
    if (normalized === "BRXXX") return "frameless";
    var suffix = normalized.slice(-2);
    if (suffix === "BK") return "black";
    if (suffix === "WE") return "white";
    if (suffix === "GD") return "gold";
    if (suffix === "SR") return "silver";
    if (suffix === "PK") return "rose";
    return "custom";
  }

  function frameSwatchOrder(code) {
    var order = {
      black: 10,
      white: 20,
      gold: 30,
      silver: 40,
      rose: 50,
      frameless: 60,
      custom: 90,
    };
    return order[frameSwatchKind(code)] || 99;
  }

  function safeImageUrl(value) {
    var text = String(value || "").trim();
    if (!text) return "";
    if (/^(https?:)?\/\//i.test(text) || text.indexOf("/") === 0 || text.indexOf("data:image/") === 0) return text;
    return "";
  }

  function safeCssColor(value) {
    var text = String(value || "").trim();
    if (!text) return "";
    if (/^#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(text)) return text;
    if (/^(?:rgb|rgba|hsl|hsla)\([0-9\s,%.+-]+\)$/i.test(text)) return text;
    if (/^[a-z]+$/i.test(text)) return text;
    return "";
  }

  function defaultFrameSwatch(code, fallbackLabel) {
    var kind = frameSwatchKind(code);
    var labels = {
      frameless: "Bez ramy",
      black: "Czarna",
      white: "Bia\u0142a",
      gold: "Z\u0142ota",
      silver: "Srebrna",
      rose: "R\u00f3\u017cowe z\u0142oto",
      custom: fallbackLabel || String(code || "Rama"),
    };
    return {
      label: labels[kind] || labels.custom,
      kind: kind,
      color: "",
      imageUrl: "",
    };
  }

  function defaultFrameSwatchImageUrl(root, kind) {
    if (!root || !root.dataset) return "";
    var key = {
      black: "frameSwatchBlack",
      white: "frameSwatchWhite",
      gold: "frameSwatchGold",
      silver: "frameSwatchSilver",
      rose: "frameSwatchRose",
      frameless: "frameSwatchFrameless",
    }[kind || ""];
    return key ? root.dataset[key] || "" : "";
  }

  function frameSwatchConfig(source, code) {
    var normalized = String(code || "").toUpperCase();
    var kind = frameSwatchKind(normalized);
    var suffix = normalized.slice(-2);
    return source[normalized] || source[kind] || source[suffix] || null;
  }

  function resolveFrameSwatch(source, code, fallbackLabel) {
    var base = defaultFrameSwatch(code, fallbackLabel);
    var custom = frameSwatchConfig(source, code);
    if (!custom) return base;
    if (typeof custom === "string") {
      return Object.assign({}, base, {
        imageUrl: safeImageUrl(custom),
        color: safeImageUrl(custom) ? "" : safeCssColor(custom),
      });
    }
    if (typeof custom !== "object" || Array.isArray(custom)) return base;
    var record = custom;
    var imageUrl = safeImageUrl(record.imageUrl || record.url || record.src);
    var color = imageUrl ? "" : safeCssColor(record.color || record.hex);
    return Object.assign({}, base, {
      label: String(record.label || record.name || record.title || base.label),
      kind: String(record.kind || base.kind),
      imageUrl: imageUrl,
      color: color,
    });
  }

  function pathFromUrl(url) {
    var value = String(url || "").trim();
    if (!value) return "";
    try {
      return new URL(value, window.location.origin).pathname;
    } catch (_error) {
      return value.split("?")[0].split("#")[0];
    }
  }

  function decodePathSegment(value) {
    try {
      return decodeURIComponent(value);
    } catch (_error) {
      return value;
    }
  }

  function odooMediaFileName(url) {
    var match = pathFromUrl(url).match(/\/ad_mirror_media\/[^/]+\/([^/]+)$/);
    return match && match[1] ? decodePathSegment(match[1]) : "";
  }

  function mediaFileName(url) {
    var path = pathFromUrl(url);
    var match = path.match(/\/ad_mirror_media\/[^/]+\/([^/]+)$/) || path.match(/\/cdn\/shop\/files\/([^/]+)$/);
    return match && match[1] ? decodePathSegment(match[1]).toLowerCase() : "";
  }

  function storefrontCdnMediaUrl(url) {
    var fileName = odooMediaFileName(url);
    if (!fileName || !window.location || !window.location.origin) return "";
    return window.location.origin.replace(/\/+$/g, "") + "/cdn/shop/files/" + encodeURIComponent(fileName);
  }

  function mediaItemFromUrl(url, alt, position) {
    var cleanUrl = String(url || "").trim();
    if (!cleanUrl) return null;
    var cdnUrl = storefrontCdnMediaUrl(cleanUrl);
    var primaryUrl = cdnUrl || cleanUrl;
    return {
      url: primaryUrl,
      fallbackUrl: cdnUrl && cdnUrl !== cleanUrl ? cleanUrl : "",
      sourceUrl: cleanUrl,
      alt: alt || "",
      position: position || 1,
    };
  }

  function productMediaItems(item, fallbackUrl, preferredUrl) {
    var rows = Array.isArray(item && item.media) ? item.media : [];
    var seen = {};
    var media = rows.map(function (entry, index) {
      var url = entry && entry.url ? String(entry.url).trim() : "";
      var alt = entry && entry.alt ? String(entry.alt) : item && item.title ? String(item.title) : item && item.sku32 ? String(item.sku32) : "";
      var position = entry && typeof entry.position === "number" && isFinite(entry.position) ? entry.position : index + 1;
      var mediaItem = mediaItemFromUrl(url, alt, position);
      var key = mediaItem ? mediaFileName(mediaItem.url) || mediaItem.url : "";
      if (!mediaItem || seen[key]) return null;
      seen[key] = true;
      return mediaItem;
    }).filter(Boolean).sort(function (left, right) {
      return left.position - right.position;
    });
    var fallback = item && item.imageUrl ? String(item.imageUrl).trim() : fallbackUrl || "";
    if (!media.length && fallback) {
      media.push(mediaItemFromUrl(fallback, item && (item.title || item.sku32) || "", 1));
    }
    if (preferredUrl && media.length > 1) {
      var preferredIndex = media.findIndex(function (entry) {
        return entry.url === preferredUrl || entry.fallbackUrl === preferredUrl || entry.sourceUrl === preferredUrl;
      });
      if (preferredIndex > 0) {
        var preferred = media.splice(preferredIndex, 1)[0];
        media.unshift(preferred);
      }
    }
    return media.slice(0, 10);
  }

  function explicitProductMediaItems(item, preferredUrl) {
    if (!item) return [];
    return productMediaItems({
      media: item.media,
      title: item.title,
      sku32: item.sku32,
      imageUrl: "",
    }, "", preferredUrl);
  }

  function productImage(item, fallbackUrl, preferredUrl) {
    var media = productMediaItems(item, fallbackUrl, preferredUrl);
    return media.length ? media[0].url : "";
  }

  function currentLocale(root) {
    var blockLocale = root && root.dataset && root.dataset.locale ? String(root.dataset.locale).slice(0, 2).toLowerCase() : "";
    if (blockLocale === "pl" || blockLocale === "en" || blockLocale === "de") return blockLocale;
    var path = window.location && window.location.pathname ? window.location.pathname : "";
    if (path === "/en" || path.indexOf("/en/") === 0) return "en";
    if (path === "/de" || path.indexOf("/de/") === 0) return "de";
    var htmlLocale = document.documentElement && document.documentElement.lang ? String(document.documentElement.lang).slice(0, 2).toLowerCase() : "";
    if (htmlLocale === "pl" || htmlLocale === "en" || htmlLocale === "de") return htmlLocale;
    var shopifyLocale = window.Shopify && window.Shopify.locale ? String(window.Shopify.locale).slice(0, 2).toLowerCase() : "";
    if (shopifyLocale === "pl" || shopifyLocale === "en" || shopifyLocale === "de") return shopifyLocale;
    return "pl";
  }

  function contentFor(item, root) {
    var content = item && item.productContent && typeof item.productContent === "object" ? item.productContent : null;
    if (!content) return null;
    var locale = currentLocale(root);
    return content[locale] || content.pl || content.en || content.de || null;
  }

  function setText(node, text) {
    if (!node) return;
    node.textContent = text || "";
    node.toggleAttribute("hidden", !String(text || "").trim());
  }

  function technicalRowsFromText(text) {
    return String(text || "").split(/\r?\n/).map(function (line) {
      var clean = line.trim();
      if (!clean) return null;
      var separator = clean.indexOf(":");
      if (separator < 1) return { label: "", value: clean };
      return {
        label: clean.slice(0, separator).trim(),
        value: clean.slice(separator + 1).trim(),
      };
    }).filter(function (row) {
      return row && row.value;
    });
  }

  function renderTechnical(node, text) {
    if (!node) return;
    var value = String(text || "");
    node.innerHTML = "";
    node.toggleAttribute("hidden", !value.trim());
    if (!value.trim()) return;
    var rows = technicalRowsFromText(value);
    if (rows.length === 0) {
      node.textContent = value;
      return;
    }
    var table = document.createElement("table");
    table.className = "ad-mirror-technical-table";
    var tbody = document.createElement("tbody");
    rows.forEach(function (row) {
      var tr = document.createElement("tr");
      if (row.label) {
        var th = document.createElement("th");
        th.scope = "row";
        th.textContent = row.label;
        tr.appendChild(th);
      }
      var td = document.createElement("td");
      if (!row.label) td.colSpan = 2;
      td.textContent = row.value;
      tr.appendChild(td);
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);
    node.appendChild(table);
  }

  function orientationLabel(value) {
    var normalized = String(value || "").toUpperCase();
    if (normalized === "H") return "pozioma";
    if (normalized === "V") return "pionowa";
    return String(value || "");
  }

  function shapeLabel(item) {
    if (!item) return "";
    var direct = String(item.shapeLabel || "").trim();
    if (direct) return direct;
    var parsedShape = item.parsedConfig && item.parsedConfig.shape || {};
    var parsedLabel = parsedShape.label && (parsedShape.label.pl || parsedShape.label.en || parsedShape.label.de) || "";
    if (parsedLabel) {
      parsedLabel = String(parsedLabel).trim();
      return parsedLabel.toLowerCase().indexOf("lustro ") === 0 ? parsedLabel : "lustro " + parsedLabel;
    }
    var code = String(item.shapeGroupKey || parsedShape.groupKey || parsedShape.rawCode || "").toUpperCase().replace(/X+$/g, "");
    var labels = {
      CH: "lustro chmurka",
      CH01: "lustro chmurka",
      DZ2: "lustro dzielone",
      EL: "lustro eliptyczne",
      FA: "lustro fala",
      FA01: "lustro fala",
      HX: "lustro heksagonalne",
      KW: "lustro kwadratowe",
      KWR: "lustro kwadratowe zaokrąglone",
      NX: "lustro nieregularne",
      NX01: "lustro nieregularne",
      OK: "lustro okrągłe",
      OW: "lustro owalne",
      PL: "lustro plaster",
      PL01: "lustro plaster",
      PO: "lustro półokrągłe",
      PR: "lustro prostokątne",
      PRR: "lustro prostokątne zaokrąglone",
    };
    return labels[code] || code;
  }

  function normalizedPurposeText(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  function purposeLabel(item) {
    if (!item) return "";
    var direct = String(item.purposeLabel || "").trim();
    if (direct) return direct;
    var parsed = item.parsedConfig || {};
    var technical = parsed.technical || {};
    var technicalLabel = String(technical.purposeLabel || "").trim();
    if (technicalLabel) return technicalLabel;
    var purpose = String(technical.purpose || "").trim();
    if (purpose === "standing") return "Lustro stojące";
    if (purpose === "decorative_wall") return "Lustro ozdobne naścienne";
    if (purpose === "wall") return "Lustro naścienne";

    var shopify = parsed.shopify || {};
    var taxonomy = shopify.taxonomy || {};
    var source = normalizedPurposeText([
      shopify.productType,
      taxonomy.categoryBreadcrumb,
      taxonomy.productType,
      taxonomy.categoryName
    ].filter(Boolean).join(" "));
    if (source.indexOf("stoj") !== -1 || source.indexOf("standing") !== -1 || source.indexOf("floor mirror") !== -1) return "Lustro stojące";
    if (source.indexOf("ozdob") !== -1 || source.indexOf("decorative") !== -1) return "Lustro ozdobne naścienne";
    if (source.indexOf("scien") !== -1 || source.indexOf("wall mirror") !== -1) return "Lustro naścienne";
    return "Lustro naścienne";
  }

  function formatMm(value) {
    var num = Number(value);
    if (!Number.isFinite(num)) return String(value || "");
    var rounded = Math.round(num * 10) / 10;
    if (Math.abs(rounded - Math.round(rounded)) < 0.001) return String(Math.round(rounded));
    return String(rounded).replace(".", ",");
  }

  function glassThicknessMm(item) {
    var technical = item && item.parsedConfig && item.parsedConfig.technical || {};
    var explicit = Number(item && (item.glassThicknessMm || item.thicknessMm) || technical.glassThicknessMm);
    if (Number.isFinite(explicit) && explicit > 0) return explicit;
    var glass = String(item && item.glassCode || "").toUpperCase();
    if (glass.indexOf("3") === 0) return 3;
    if (glass.indexOf("4") === 0) return 4;
    return 0;
  }

  function mountingDepthOffsetMm(item) {
    var reserve = canonicalReserveCode(item && item.reserveCode);
    if (reserve === "M00") return 0;
    if (reserve === "MKL") return 11;
    if (reserve === "MZK") return 2;
    return 11;
  }

  function mirrorDepthMm(item) {
    var glass = glassThicknessMm(item);
    var offset = mountingDepthOffsetMm(item);
    var total = glass + offset;
    return total > 0 ? total : 0;
  }

  function technicalTextForItem(item) {
    if (!item) return "";
    var labels = item.labels || {};
    var rows = [];
    var width = numericCm(item.widthCm);
    var height = numericCm(item.heightCm);
    var glass = String(item.glassCode || "").toUpperCase();
    var depth = mirrorDepthMm(item);
    function add(label, value) {
      var clean = String(value || "").trim();
      if (clean) rows.push(label + ": " + clean);
    }
    if (width && height) {
      add("Szerokość", formatCm(width) + " cm");
      add("Wysokość", formatCm(height) + " cm");
    }
    if (depth) add("Głębokość +/- 1mm", formatMm(depth) + " mm");
    add("Kształt", shapeLabel(item) || labels.shapeGroupKey || item.shapeGroupKey);
    add("Orientacja", orientationLabel(item.orientation));
    add("Przeznaczenie", purposeLabel(item));
    add("Rodzaj mocowania", labels.reserveCode || reserveLabel(item.reserveCode));
    add("Materiał", "szkło");
    if (glass) add("Grubość tafli", glass.indexOf("3") === 0 ? "3 mm" : "4 mm");
    add("Krawędź", "krawędź bezpieczna");
    add("Rama", labels.frameCode || item.frameCode);
    add("Podświetlenie", labels.ledCode || ledLabel(item.ledCode));
    if (labels.featuresCode && labels.featuresCode !== "Brak") add("Funkcje", labels.featuresCode);
    return rows.join("\n");
  }

  function mergeTechnicalText(item, extraText) {
    var baseRows = technicalRowsFromText(technicalTextForItem(item));
    var usedLabels = new Set();
    baseRows.forEach(function (row) {
      if (row.label) usedLabels.add(row.label.trim().toLowerCase());
    });
    var extraRows = technicalRowsFromText(extraText).filter(function (row) {
      var label = String(row.label || "").trim();
      if (!label) return Boolean(String(row.value || "").trim());
      var key = label.toLowerCase();
      if (key === "wymiary" || key === "sposób mocowania" || usedLabels.has(key)) return false;
      usedLabels.add(key);
      return true;
    });
    return baseRows.concat(extraRows).map(function (row) {
      return row.label ? row.label + ": " + row.value : row.value;
    }).join("\n");
  }

  function renderDownloads(node, downloads) {
    if (!node) return;
    node.innerHTML = "";
    var rows = Array.isArray(downloads) ? downloads.filter(function (row) {
      return row && row.label;
    }) : [];
    if (rows.length === 0) {
      var empty = document.createElement("span");
      empty.textContent = "Brak plików do pobrania.";
      node.appendChild(empty);
      return;
    }
    rows.forEach(function (row) {
      var link = document.createElement("a");
      link.href = row.url || "#";
      link.target = "_blank";
      link.rel = "noreferrer";
      link.textContent = row.label;
      node.appendChild(link);
    });
  }

  function init(root) {
    if (!root || root.dataset.adMirrorStandardInit === "true") return;
    root.dataset.adMirrorStandardInit = "true";

    var controls = root.querySelector("[data-standard-controls]");
    var image = root.querySelector("[data-standard-image]");
    var fallbackImageUrl = image ? image.currentSrc || image.src || "" : "";
    if (fallbackImageUrl && fallbackImageUrl.indexOf("mirror-standard-placeholder.svg") >= 0) fallbackImageUrl = "";
    if (!fallbackImageUrl) {
      var nativeImage = document.querySelector(".product__media-wrapper img, media-gallery img, [id^='MediaGallery-'] img, .product__media img");
      fallbackImageUrl = nativeImage ? nativeImage.currentSrc || nativeImage.src || "" : "";
    }
    function nativeMediaImages() {
      return Array.from(document.querySelectorAll(".product__media-wrapper img, media-gallery img, [id^='MediaGallery-'] img, .product__media img")).filter(function (img) {
        return img !== image && !(img.closest && img.closest(".ad-mirror-standard__media")) && !root.contains(img);
      });
    }

    function imageContainer(img) {
      if (!img.closest) return img;
      if (img.closest(".thumbnail-list, [id^='Slider-Thumbnails'], .thumbnail-slider")) return null;
      return img.closest(".product__media-item, .product__media-list .slider__slide") || img;
    }

    var nativeMediaSnapshot = nativeMediaImages().map(function (img) {
      var picture = img.closest ? img.closest("picture") : null;
      return {
        img: img,
        src: img.getAttribute("src") || "",
        srcset: img.getAttribute("srcset") || "",
        dataSrc: img.getAttribute("data-src") || "",
        dataSrcset: img.getAttribute("data-srcset") || "",
        alt: img.getAttribute("alt") || "",
        anchor: img.closest ? img.closest("a[href]") : null,
        href: img.closest && img.closest("a[href]") ? img.closest("a[href]").getAttribute("href") || "" : "",
        sources: picture ? Array.from(picture.querySelectorAll("source")).map(function (sourceNode) {
          return {
            node: sourceNode,
            srcset: sourceNode.getAttribute("srcset") || "",
            dataSrcset: sourceNode.getAttribute("data-srcset") || "",
          };
        }) : [],
      };
    });

    function restoreNativeMedia() {
      nativeMediaSnapshot.forEach(function (entry) {
        if (!entry.img || !document.documentElement.contains(entry.img)) return;
        if (entry.src) entry.img.setAttribute("src", entry.src);
        if (entry.srcset) entry.img.setAttribute("srcset", entry.srcset);
        else entry.img.removeAttribute("srcset");
        if (entry.dataSrc) entry.img.setAttribute("data-src", entry.dataSrc);
        else entry.img.removeAttribute("data-src");
        if (entry.dataSrcset) entry.img.setAttribute("data-srcset", entry.dataSrcset);
        else entry.img.removeAttribute("data-srcset");
        if (entry.alt) entry.img.alt = entry.alt;
        if (entry.anchor && document.documentElement.contains(entry.anchor) && entry.href) entry.anchor.setAttribute("href", entry.href);
        entry.sources.forEach(function (source) {
          if (!source.node || !document.documentElement.contains(source.node)) return;
          if (source.srcset) source.node.setAttribute("srcset", source.srcset);
          else source.node.removeAttribute("srcset");
          if (source.dataSrcset) source.node.setAttribute("data-srcset", source.dataSrcset);
          else source.node.removeAttribute("data-srcset");
        });
      });
    }

    function setNativeMediaVisibleCount(count) {
      var containers = [];
      nativeMediaImages().forEach(function (img) {
        var container = imageContainer(img);
        if (!container || containers.indexOf(container) >= 0) return;
        containers.push(container);
      });
      containers.forEach(function (container, index) {
        var hidden = index >= count;
        container.toggleAttribute("hidden", hidden);
        container.style.display = hidden ? "none" : "";
      });
    }

    function isCurrentProductItem(item) {
      return !!(item && item.productGid && root.dataset.currentProductGid && item.productGid === root.dataset.currentProductGid);
    }

    function firstSrcsetUrl(srcset) {
      var first = String(srcset || "").split(",")[0] || "";
      return first.trim().split(/\s+/)[0] || "";
    }

    function mediaKey(url) {
      var clean = String(url || "").trim();
      if (!clean) return "";
      var fileName = mediaFileName(clean);
      if (fileName) return "file:" + fileName;
      try {
        var parsed = new URL(clean, window.location.origin);
        ["width", "height", "crop", "format", "quality", "auto"].forEach(function (param) {
          parsed.searchParams.delete(param);
        });
        return parsed.origin + parsed.pathname + "?" + parsed.searchParams.toString();
      } catch (error) {
        return clean.replace(/([?&](width|height|crop|format|quality|auto)=[^&]*)/g, "");
      }
    }

    function pushMediaItem(target, seen, entry) {
      if (!entry || !entry.url) return;
      var url = String(entry.url).trim();
      var key = mediaKey(url);
      if (!url || !key || seen[key]) return;
      seen[key] = true;
      target.push({
        url: url,
        fallbackUrl: entry.fallbackUrl || "",
        sourceUrl: entry.sourceUrl || "",
        alt: entry.alt || "",
        position: entry.position || target.length + 1,
      });
    }

    function nativeSnapshotMediaItems() {
      var media = [];
      var seen = {};
      nativeMediaSnapshot.forEach(function (entry, index) {
        var url = entry.href || entry.src || entry.dataSrc || firstSrcsetUrl(entry.srcset) || firstSrcsetUrl(entry.dataSrcset);
        pushMediaItem(media, seen, {
          url: url,
          alt: entry.alt || "",
          position: index + 1,
        });
      });
      return media;
    }

    function preferredMediaUrl(media, preferredUrl) {
      if (!media || !media.length) return "";
      var preferredKey = mediaKey(preferredUrl);
      if (preferredKey) {
        var preferred = media.find(function (entry) {
          return mediaKey(entry.url) === preferredKey || mediaKey(entry.fallbackUrl) === preferredKey || mediaKey(entry.sourceUrl) === preferredKey;
        });
        if (preferred) return preferred.url;
      }
      return media[0].url;
    }

    function mediaItemByUrl(media, url) {
      var key = mediaKey(url);
      if (!key || !media || !media.length) return null;
      return media.find(function (entry) {
        return mediaKey(entry.url) === key || mediaKey(entry.fallbackUrl) === key || mediaKey(entry.sourceUrl) === key;
      }) || null;
    }

    function resolvedMediaItems(item, preferredUrl) {
      if (!item) return [];
      var media = [];
      var seen = {};
      var isCurrent = isCurrentProductItem(item) || (!!root.dataset.currentProductHandle && item.handle === root.dataset.currentProductHandle);
      productMediaItems(item, "", preferredUrl).forEach(function (entry) {
        pushMediaItem(media, seen, entry);
      });
      if (item.imageUrl) {
        pushMediaItem(media, seen, {
          url: item.imageUrl,
          alt: item.title || item.sku32 || "",
          position: media.length + 1,
        });
      }
      if (isCurrent && fallbackImageUrl) {
        pushMediaItem(media, seen, {
          url: fallbackImageUrl,
          alt: item.title || item.sku32 || "",
          position: media.length + 1,
        });
      }
      if (isCurrent) {
        nativeSnapshotMediaItems().forEach(function (entry) {
          pushMediaItem(media, seen, entry);
        });
      }
      if (preferredUrl && media.length > 1) {
        var preferredKey = mediaKey(preferredUrl);
        var preferredIndex = media.findIndex(function (entry) {
          return mediaKey(entry.url) === preferredKey || mediaKey(entry.fallbackUrl) === preferredKey || mediaKey(entry.sourceUrl) === preferredKey;
        });
        if (preferredIndex > 0) {
          var preferred = media.splice(preferredIndex, 1)[0];
          media.unshift(preferred);
        }
      }
      return media.slice(0, 10);
    }

    function thumbnailMediaItems(item) {
      var media = [];
      var seen = {};
      resolvedMediaItems(item, "").forEach(function (entry) {
        pushMediaItem(media, seen, entry);
      });
      return media.slice(0, 10);
    }

    function selectedItemFromUrl() {
      try {
        var url = new URL(window.location.href);
        var requestedSku = String(url.searchParams.get("ad_sku32") || url.searchParams.get("sku32") || "").toUpperCase();
        var requestedHandle = String(url.searchParams.get("ad_product") || "").trim();
        var productPath = url.pathname.match(/\/products\/([^/?#]+)/);
        var pathHandle = productPath ? decodeURIComponent(productPath[1]) : "";
        if (requestedSku) {
          var bySku = items.find(function (item) {
            return String(item.sku32 || "").toUpperCase() === requestedSku;
          });
          if (bySku) return bySku;
        }
        if (requestedHandle) {
          var byRequestedHandle = items.find(function (item) {
            return item.handle === requestedHandle;
          });
          if (byRequestedHandle) return byRequestedHandle;
        }
        if (pathHandle) {
          var byPathHandle = items.find(function (item) {
            return item.handle === pathHandle;
          });
          if (byPathHandle) return byPathHandle;
        }
      } catch (error) {
        return null;
      }
      return null;
    }

    function updateUrlForItem(item) {
      if (!item || !item.sku32 || !window.history || !window.history.replaceState || root.dataset.updateUrl === "false") return;
      try {
        var url = new URL(window.location.href);
        var isPreview = url.searchParams.has("preview_key") || url.pathname.indexOf("products_preview") >= 0;
        if (!isPreview && item.url && String(item.url).indexOf("/products/") === 0) {
          url.pathname = new URL(item.url, window.location.origin).pathname;
        }
        url.searchParams.set("ad_sku32", item.sku32);
        if (item.handle) url.searchParams.set("ad_product", item.handle);
        else url.searchParams.delete("ad_product");
        window.history.replaceState({ adMirrorSku32: item.sku32 }, "", url.toString());
      } catch (error) {
        // URL persistence is a progressive enhancement; selection must still work without it.
      }
    }

    var selectedMediaUrl = "";
    var mediaPanel = root.querySelector(".ad-mirror-standard__media");
    var thumbs = root.querySelector("[data-standard-thumbs]");
    var title = root.querySelector("[data-standard-title]");
    var skuNode = root.querySelector("[data-standard-sku]");
    var priceNode = root.querySelector("[data-standard-price]");
    var notice = root.querySelector("[data-standard-notice]");
    var variantInput = root.querySelector("[data-standard-variant-id]");
    var submit = root.querySelector("[data-standard-submit]");
    var link = root.querySelector("[data-standard-link]");
    var form = root.querySelector("[data-standard-form]");
    var details = root.querySelector("[data-standard-details]");
    var descriptionNode = details && details.querySelector("[data-standard-description]");
    var technicalNode = details && details.querySelector("[data-standard-technical]");
    var downloadsNode = details && details.querySelector("[data-standard-downloads]");
    var warningNode = root.querySelector("[data-standard-warning]");
    if (technicalNode && !technicalNode.querySelector(".ad-mirror-technical-table")) {
      renderTechnical(technicalNode, technicalNode.textContent);
    }
    var props = {};
    root.querySelectorAll("[data-standard-property]").forEach(function (input) {
      props[input.dataset.standardProperty] = input;
    });

    var frameSwatches = parseJsonObject(root.dataset.frameSwatches);
    var items = parseJson(root.dataset.standardItems, []).map(function (item) {
      return enrich(item, root);
    }).filter(function (item) {
      return item.variantId && item.sku32;
    });
    var state = {};
    var delayedRangeCommit = 0;

    function clearDelayedRangeCommit() {
      if (!delayedRangeCommit) return;
      window.clearTimeout(delayedRangeCommit);
      delayedRangeCommit = 0;
    }

    function scheduleDelayedRangeCommit(callback, delay) {
      clearDelayedRangeCommit();
      delayedRangeCommit = window.setTimeout(function () {
        delayedRangeCommit = 0;
        callback();
      }, delay || 1000);
    }

    function valueOf(item, attribute) {
      return String(item[attribute] || "");
    }

    function attributeIndex(attribute) {
      for (var i = 0; i < MATCH_ATTRIBUTES.length; i += 1) {
        if (MATCH_ATTRIBUTES[i][0] === attribute) return i;
      }
      return -1;
    }

    function matchesBefore(item, attribute) {
      var limit = attributeIndex(attribute);
      return MATCH_ATTRIBUTES.slice(0, Math.max(0, limit)).every(function (pair) {
        var key = pair[0];
        return !state[key] || valueOf(item, key) === String(state[key]);
      });
    }

    function availableValues(attribute) {
      return uniqueAttributeValues(attribute, items.filter(function (item) {
        return matchesBefore(item, attribute);
      }).map(function (item) {
        return valueOf(item, attribute);
      }));
    }

    function exactMatch() {
      var candidates = items.filter(function (item) {
        return MATCH_ATTRIBUTES.every(function (pair) {
          var attribute = pair[0];
          return !state[attribute] || valueOf(item, attribute) === String(state[attribute]);
        });
      });
      if (candidates.length === 0) return null;
      return candidates.find(function (item) {
        return state.glassCode && valueOf(item, "glassCode") === String(state.glassCode);
      }) || candidates[0] || null;
    }

    function chooseFirst() {
      var currentHandle = String(root.dataset.currentProductHandle || "");
      return selectedItemFromUrl() || items.find(function (item) {
        return item.productGid === root.dataset.currentProductGid;
      }) || items.find(function (item) {
        return currentHandle && item.handle === currentHandle;
      }) || items[0] || null;
    }

    function setInitialState() {
      var current = chooseFirst();
      if (!current) return;
      MATCH_ATTRIBUTES.forEach(function (pair) {
        state[pair[0]] = valueOf(current, pair[0]);
      });
      state.glassCode = valueOf(current, "glassCode");
    }

    function reconcile() {
      MATCH_ATTRIBUTES.forEach(function (pair) {
        var attribute = pair[0];
        var available = availableValues(attribute);
        if (available.indexOf(String(state[attribute] || "")) < 0) state[attribute] = available[0] || "";
      });
    }

    function label(attribute, value) {
      var source = items.find(function (item) {
        return valueOf(item, attribute) === String(value);
      });
      return source && source.labels ? source.labels[attribute] || String(value || "") : String(value || "");
    }

    function hideNativeControls() {
      document.documentElement.setAttribute("data-ad-mirror-product-page", "true");
      document.querySelectorAll(HIDDEN_SELECTORS).forEach(function (node) {
        if (root.contains(node)) return;
        node.setAttribute("data-ad-mirror-native-hidden", "true");
        node.setAttribute("hidden", "hidden");
      });
    }

    function placeBlock() {
      var info = document.querySelector("product-info, .product__info-container, [id^='ProductInfo-'], .product__info-wrapper");
      if (!info || info.contains(root)) return;
      var anchor = info.querySelector("form[action*='/cart/add'], product-form, .product-form, .product__description, share-button, .product__accordion");
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(root, anchor);
      else info.appendChild(root);
    }

    function placeDetails() {
      if (!details) return;
      var media = document.querySelector(".product__media-wrapper") || document.querySelector("media-gallery, [id^='MediaGallery-'], .product__media-list");
      var host = media && media.matches && media.matches("media-gallery, [id^='MediaGallery-']") && media.parentElement ? media.parentElement : media;
      if (!host || host.contains(details)) return;
      host.appendChild(details);
    }

    function placeFallbackMedia() {
      if (!mediaPanel || !image) return;
      var hasNativeMedia = nativeMediaSnapshot.length > 0 || nativeMediaImages().length > 0;
      var media = document.querySelector(".product__media-wrapper") || document.querySelector("media-gallery, [id^='MediaGallery-'], .product__media-list");
      var host = media && media.matches && media.matches("media-gallery, [id^='MediaGallery-']") && media.parentElement ? media.parentElement : media;
      if (hasNativeMedia) {
        mediaPanel.removeAttribute("data-standard-media-fallback");
        mediaPanel.removeAttribute("data-standard-media-thumbs");
        document.documentElement.removeAttribute("data-ad-mirror-standard-media-fallback");
        document.documentElement.removeAttribute("data-ad-mirror-standard-media-thumbs");
        if (!root.contains(mediaPanel)) root.insertBefore(mediaPanel, root.firstChild);
        return;
      }
      mediaPanel.removeAttribute("data-standard-media-thumbs");
      document.documentElement.removeAttribute("data-ad-mirror-standard-media-thumbs");
      if (!host) {
        mediaPanel.removeAttribute("data-standard-media-fallback");
        document.documentElement.removeAttribute("data-ad-mirror-standard-media-fallback");
        if (!root.contains(mediaPanel)) root.insertBefore(mediaPanel, root.firstChild);
        return;
      }
      mediaPanel.setAttribute("data-standard-media-fallback", "true");
      document.documentElement.setAttribute("data-ad-mirror-standard-media-fallback", "true");
      if (mediaPanel.parentElement !== host) {
        if (details && details.parentNode === host) host.insertBefore(mediaPanel, details);
        else host.insertBefore(mediaPanel, host.firstChild);
      }
    }

    function productMediaTarget() {
      return document.querySelector(".product__media-wrapper") || document.querySelector("media-gallery, [id^='MediaGallery-'], .product__media-list") || root.querySelector("[data-standard-image]") || root;
    }

    function productMediaScrollTarget() {
      var target = productMediaTarget();
      return target && target.querySelector ? target.querySelector("img") || target : target;
    }

    function stickyHeaderOffset() {
      var offset = 24;
      if (!window.matchMedia || !window.matchMedia("(max-width: 749px)").matches) return offset;
      var header = document.querySelector("sticky-header, .shopify-section-header-sticky, .section-header, .header-wrapper");
      if (!header) return 76;
      var rect = header.getBoundingClientRect();
      return Math.max(76, Math.ceil(rect.height) + 18);
    }

    function scrollToProductMedia(event) {
      if (event && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0)) return;
      if (event) event.preventDefault();
      var target = productMediaScrollTarget();
      if (!target || !target.getBoundingClientRect) return;
      var rect = target.getBoundingClientRect();
      var top = Math.max(0, window.pageYOffset + rect.top - stickyHeaderOffset());
      window.scrollTo({ top: top, behavior: "smooth" });
    }

    function updateNativePrice(text) {
      document.querySelectorAll(".price .price-item,.price-item").forEach(function (node) {
        if (!root.contains(node)) node.textContent = text;
      });
    }

    function updateNativeTitle(text) {
      if (!text) return;
      var selectors = [".product__title h1", ".product__title", "h1"];
      for (var i = 0; i < selectors.length; i += 1) {
        var node = document.querySelector(selectors[i]);
        if (node && !root.contains(node)) {
          node.textContent = text;
          return;
        }
      }
    }

    function applyImageSource(img, source) {
      if (!img || !source) return;
      img.src = source;
      img.srcset = source;
      img.setAttribute("src", source);
      img.setAttribute("srcset", source);
      img.setAttribute("data-src", source);
      img.setAttribute("data-srcset", source);
      var picture = img.closest ? img.closest("picture") : null;
      if (picture) {
        picture.querySelectorAll("source").forEach(function (sourceNode) {
          sourceNode.setAttribute("srcset", source);
          sourceNode.setAttribute("data-srcset", source);
        });
      }
      var anchor = img.closest ? img.closest("a[href]") : null;
      if (anchor && !root.contains(anchor)) anchor.setAttribute("href", source);
    }

    function setImageSource(img, source, alt, fallbackSource) {
      if (!img || !source) return;
      var fallback = String(fallbackSource || "").trim();
      if (fallback && fallback === String(source || "").trim()) fallback = "";
      img.onerror = null;
      if (fallback) {
        img.setAttribute("data-ad-mirror-fallback-src", fallback);
        img.onerror = function () {
          var next = img.getAttribute("data-ad-mirror-fallback-src") || "";
          if (!next || String(img.currentSrc || img.src || "").trim() === next) return;
          img.removeAttribute("data-ad-mirror-fallback-src");
          img.onerror = null;
          applyImageSource(img, next);
        };
      } else {
        img.removeAttribute("data-ad-mirror-fallback-src");
      }
      applyImageSource(img, source);
      if (alt) img.alt = alt;
    }

    function updateNativeMedia(item, mediaItems, fallbackSource) {
      var media = mediaItems && mediaItems.length ? mediaItems : resolvedMediaItems(item, fallbackSource || selectedMediaUrl);
      var images = nativeMediaImages();
      if (!images.length) return;
      if (!media.length) {
        restoreNativeMedia();
        if (isCurrentProductItem(item)) {
          setNativeMediaVisibleCount(999);
        }
        return;
      }
      setNativeMediaVisibleCount(media.length);
      for (var i = 0; i < images.length; i += 1) {
        var img = images[i];
        var mediaItem = media[i % media.length];
        setImageSource(img, mediaItem.url, mediaItem.alt || item.title || item.sku32, mediaItem.fallbackUrl || "");
      }
    }

    function applyItem(item) {
      var price = money(item.price, item.currency);
      var mediaItems = resolvedMediaItems(item, selectedMediaUrl);
      selectedMediaUrl = preferredMediaUrl(mediaItems, selectedMediaUrl);
      var selectedMediaItem = mediaItemByUrl(mediaItems, selectedMediaUrl) || mediaItems[0] || null;
      var imageSource = selectedMediaItem ? selectedMediaItem.url : productImage(item, isCurrentProductItem(item) ? fallbackImageUrl : "", selectedMediaUrl);
      if (image) {
        if (imageSource) setImageSource(image, imageSource, item.title || item.sku32, selectedMediaItem && selectedMediaItem.fallbackUrl || "");
        image.alt = item.title || item.sku32;
      }
      if (title) title.textContent = item.title || item.sku32;
      updateNativeTitle(item.title || item.sku32);
      updateNativeMedia(item, mediaItems, imageSource);
      if (skuNode) skuNode.textContent = item.sku32;
      if (priceNode && price) priceNode.textContent = price;
      if (price) updateNativePrice(price);
      if (variantInput) variantInput.value = item.variantId || "";
      if (link) link.href = item.url || "/products/" + (item.handle || "");
      if (props.sku32) props.sku32.value = item.sku32;
      if (props.shapeGroupKey) props.shapeGroupKey.value = item.shapeGroupKey;
      if (props.configuratorGroupKey) props.configuratorGroupKey.value = item.configuratorGroupKey;
      if (props.productGroupKey) props.productGroupKey.value = item.productGroupKey;
      if (props.shapeLabel) props.shapeLabel.value = (item.labels && item.labels.shapeGroupKey) || "";
      if (props.glassLabel) props.glassLabel.value = (item.labels && item.labels.glassCode) || "";
      if (props.sizeLabel) props.sizeLabel.value = (item.labels && item.labels.sizeCode) || "";
      if (props.frameLabel) props.frameLabel.value = (item.labels && item.labels.frameCode) || "";
      if (props.ledLabel) props.ledLabel.value = (item.labels && item.labels.ledCode) || "";
      if (props.featuresLabel) props.featuresLabel.value = (item.labels && item.labels.featuresCode) || "";
      if (props.reserveLabel) props.reserveLabel.value = (item.labels && item.labels.reserveCode) || "";
      var selectedContent = contentFor(item, root);
      if (selectedContent) {
        setText(descriptionNode, selectedContent.description);
        renderTechnical(technicalNode, mergeTechnicalText(item, selectedContent.technical));
        setText(warningNode, selectedContent.warning);
        renderDownloads(downloadsNode, selectedContent.downloads);
      } else {
        renderTechnical(technicalNode, mergeTechnicalText(item));
      }
      if (submit) submit.disabled = !item.variantId || item.available === false;
      if (notice) notice.textContent = item.available === false ? "Wybrany wariant jest niedostępny." : "";
      updateUrlForItem(item);
    }

    function renderThumbs(selected) {
      if (!thumbs) return;
      thumbs.innerHTML = "";
      var mediaItems = thumbnailMediaItems(selected);
      thumbs.dataset.count = String(mediaItems.length);
      thumbs.hidden = mediaItems.length === 0;
      thumbs.toggleAttribute("aria-hidden", mediaItems.length === 0);
      mediaItems.forEach(function (mediaItem, index) {
        var button = document.createElement("button");
        var thumbImage = document.createElement("img");
        var thumbLabel = document.createElement("span");
        var isPressed = mediaKey(mediaItem.url) === mediaKey(selectedMediaUrl) || (!selectedMediaUrl && index === 0);
        button.type = "button";
        button.className = "ad-mirror-standard__thumb";
        button.setAttribute("aria-pressed", isPressed ? "true" : "false");
        button.setAttribute("aria-label", "Zdjecie " + (index + 1));
        setImageSource(thumbImage, mediaItem.url, mediaItem.alt || selected.title || selected.sku32 || "", mediaItem.fallbackUrl || "");
        thumbImage.loading = index === 0 ? "eager" : "lazy";
        thumbImage.decoding = "async";
        thumbLabel.textContent = "Zdjecie " + (index + 1);
        button.appendChild(thumbImage);
        button.appendChild(thumbLabel);
        button.addEventListener("click", function () {
          selectedMediaUrl = mediaItem.url;
          if (image) setImageSource(image, mediaItem.url, mediaItem.alt || selected.title || selected.sku32, mediaItem.fallbackUrl || "");
          updateNativeMedia(selected, resolvedMediaItems(selected, selectedMediaUrl), mediaItem.url);
          renderThumbs(selected);
        });
        thumbs.appendChild(button);
      });
    }

    function shouldUseSelect(attribute, values) {
      return values.length >= 4;
    }

    function renderSelect(group, attribute, titleText, values) {
      var select = document.createElement("select");
      select.className = "ad-mirror-standard__select";
      select.setAttribute("aria-label", titleText);
      values.forEach(function (value) {
        var option = document.createElement("option");
        option.value = String(value);
        option.textContent = label(attribute, value);
        option.selected = String(state[attribute] || "") === String(value);
        select.appendChild(option);
      });
      select.addEventListener("change", function () {
        state[attribute] = String(select.value);
        reconcile();
        render();
      });
      group.appendChild(select);
    }

    function dimensionPairs() {
      var map = new Map();
      items.filter(function (item) {
        return matchesBefore(item, "sizeCode");
      }).forEach(function (item) {
        var width = numericCm(item.widthCm);
        var height = numericCm(item.heightCm);
        if (!width || !height) return;
        var key = width + "x" + height;
        if (!map.has(key)) {
          map.set(key, {
            width: width,
            height: height,
            sizeCode: valueOf(item, "sizeCode"),
          });
        }
      });
      return Array.from(map.values()).sort(function (left, right) {
        return left.width - right.width || left.height - right.height || String(left.sizeCode).localeCompare(String(right.sizeCode));
      });
    }

    function selectedDimensionPair(pairs) {
      var current = String(state.sizeCode || "");
      return pairs.find(function (pair) {
        return String(pair.sizeCode) === current;
      }) || pairs[0] || null;
    }

    function closestPair(pairs, targetWidth, targetHeight, lock) {
      if (!pairs.length) return null;
      var targetW = numericCm(targetWidth);
      var targetH = numericCm(targetHeight);
      var locked = pairs.filter(function (pair) {
        if (lock === "width") return pair.width === targetW;
        if (lock === "height") return pair.height === targetH;
        return true;
      });
      var pool = locked.length ? locked : pairs;
      return pool.slice().sort(function (left, right) {
        var leftScore = Math.abs(left.width - targetW) * 1000 + Math.abs(left.height - targetH);
        var rightScore = Math.abs(right.width - targetW) * 1000 + Math.abs(right.height - targetH);
        return leftScore - rightScore || left.width - right.width || left.height - right.height;
      })[0] || null;
    }

    function renderRange(group, config) {
      var values = (config.values || []).map(Number).filter(function (value) {
        return Number.isFinite(value);
      }).sort(function (left, right) { return left - right; });
      if (!values.length) return;
      var selected = Number.isFinite(Number(config.value)) ? Number(config.value) : numericCm(config.selected || values[0]);
      var selectedIndex = closestValueIndex(values, selected);
      var current = values[selectedIndex];
      var field = document.createElement("div");
      var row = document.createElement("div");
      var labelNode = document.createElement("span");
      var output = document.createElement("output");
      var input = document.createElement("input");
      var maxIndex = Math.max(0, values.length - 1);
      var percent = maxIndex > 0 ? (selectedIndex / maxIndex) * 100 : 0;

      field.className = "ad-mirror-standard__range-field";
      row.className = "ad-mirror-standard__range-label";
      labelNode.textContent = config.label;
      output.textContent = formatCm(current) + " cm";
      input.type = "range";
      input.className = "ad-mirror-standard__range";
      input.min = "0";
      input.max = String(maxIndex);
      input.step = "1";
      input.value = String(selectedIndex);
      input.disabled = values.length <= 1;
      input.setAttribute("aria-label", config.label);
      input.style.setProperty("--ad-mirror-range-progress", percent + "%");
      function readRawIndex() {
        return Math.max(0, Math.min(maxIndex, Number(input.value) || 0));
      }
      function nearestIndex(rawIndex) {
        return Math.max(0, Math.min(maxIndex, Math.round(rawIndex)));
      }
      function readValue() {
        return values[nearestIndex(readRawIndex())] || values[0];
      }
      function updatePreview() {
        var rawIndex = readRawIndex();
        var index = nearestIndex(rawIndex);
        var value = values[index] || values[0];
        var progress = maxIndex > 0 ? (rawIndex / maxIndex) * 100 : 0;
        output.textContent = formatCm(value) + " cm";
        input.style.setProperty("--ad-mirror-range-progress", progress + "%");
        if (config.onPreview) config.onPreview(value);
      }
      function commit() {
        clearDelayedRangeCommit();
        var index = nearestIndex(readRawIndex());
        var value = readValue();
        input.value = String(index);
        input.style.setProperty("--ad-mirror-range-progress", (maxIndex > 0 ? (index / maxIndex) * 100 : 0) + "%");
        updatePreview();
        config.onChange(value);
      }
      function scheduleCommit() {
        updatePreview();
        scheduleDelayedRangeCommit(commit, config.commitDelayMs || 1000);
      }
      input.addEventListener("input", scheduleCommit, { passive: true });
      input.addEventListener("change", scheduleCommit);
      input.addEventListener("pointerup", scheduleCommit);
      input.addEventListener("blur", commit);
      input.addEventListener("keyup", function (event) {
        if (event.key === "ArrowLeft" || event.key === "ArrowRight" || event.key === "Home" || event.key === "End") scheduleCommit();
      });

      row.appendChild(labelNode);
      row.appendChild(output);
      field.appendChild(row);
      field.appendChild(input);
      group.appendChild(field);
    }

    function renderSizeSliders(group) {
      var pairs = dimensionPairs();
      var selectedPair = selectedDimensionPair(pairs);
      if (!selectedPair || pairs.length <= 1) return;
      var isRound = String(state.shapeGroupKey || "").toUpperCase() === "OK";
      var sliders = document.createElement("div");
      var sliderState = state._sizeSliders || {};
      state._sizeSliders = sliderState;

      group.classList.add("ad-mirror-standard__group--size");
      sliders.className = "ad-mirror-standard__size-sliders";
      group.appendChild(sliders);

      if (isRound) {
        var diameterOptions = unique(pairs.map(function (pair) {
          return String(pair.width || pair.height);
        })).map(Number).sort(function (left, right) { return left - right; });
        var selectedDiameter = selectedPair.width || selectedPair.height;
        var currentDiameter = Number.isFinite(Number(sliderState.diameterCm)) ? sliderState.diameterCm : selectedDiameter;
        renderRange(sliders, {
          label: "Średnica",
          values: diameterOptions,
          value: currentDiameter,
          selected: selectedDiameter,
          step: 1,
          commitDelayMs: 1000,
          onPreview: function (diameter) {
            sliderState.diameterCm = diameter;
          },
          onChange: function (diameter) {
            sliderState.diameterCm = diameter;
            var next = closestPair(pairs, diameter, diameter, "");
            if (next) state.sizeCode = String(next.sizeCode);
            reconcile();
            scheduleRender();
          },
        });
        return;
      }

      var value = document.createElement("strong");
      value.className = "ad-mirror-standard__size-value";
      value.textContent = formatCm(selectedPair.width) + "x" + formatCm(selectedPair.height) + " cm";
      value.setAttribute("aria-live", "polite");
      group.insertBefore(value, sliders);

      var widths = unique(pairs.map(function (pair) { return String(pair.width); })).map(Number).sort(function (left, right) { return left - right; });
      var selectedWidth = numericCm(selectedPair.width);
      var heights = unique(pairs.filter(function (pair) {
        return numericCm(pair.width) === selectedWidth;
      }).map(function (pair) { return String(pair.height); })).map(Number).sort(function (left, right) { return left - right; });
      var currentWidth = Number.isFinite(Number(sliderState.widthCm)) ? sliderState.widthCm : selectedPair.width;
      var currentHeight = Number.isFinite(Number(sliderState.heightCm)) ? sliderState.heightCm : selectedPair.height;
      renderRange(sliders, {
        label: "Szerokość",
        values: widths,
        value: currentWidth,
        selected: selectedPair.width,
        step: 1,
        commitDelayMs: 1000,
        onPreview: function (width) {
          sliderState.widthCm = width;
        },
        onChange: function (width) {
          sliderState.widthCm = width;
          var next = closestPair(pairs, width, Number.isFinite(Number(sliderState.heightCm)) ? sliderState.heightCm : selectedPair.height, "width");
          if (next) state.sizeCode = String(next.sizeCode);
          reconcile();
          scheduleRender();
        },
      });
      renderRange(sliders, {
        label: "Wysokość",
        values: heights,
        value: currentHeight,
        selected: selectedPair.height,
        step: 1,
        commitDelayMs: 1000,
        onPreview: function (height) {
          sliderState.heightCm = height;
        },
        onChange: function (height) {
          sliderState.heightCm = height;
          var next = closestPair(pairs, Number.isFinite(Number(sliderState.widthCm)) ? sliderState.widthCm : selectedPair.width, height, "width");
          if (next) state.sizeCode = String(next.sizeCode);
          reconcile();
          scheduleRender();
        },
      });
    }

    function renderSegments(group, attribute, titleText, values) {
      var row = document.createElement("div");
      row.className = "ad-mirror-standard__segments";
      row.setAttribute("role", "group");
      row.setAttribute("aria-label", titleText);
      values.forEach(function (value) {
        var button = document.createElement("button");
        button.type = "button";
        button.textContent = label(attribute, value);
        var active = String(state[attribute] || "") === String(value);
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
        button.addEventListener("click", function () {
          state[attribute] = String(value);
          reconcile();
          render();
        });
        row.appendChild(button);
      });
      group.appendChild(row);
    }

    function renderLedSegments(group, attribute, titleText, values) {
      var row = document.createElement("div");
      var selectedValue = String(state[attribute] || values[0] || "");
      var descriptionId = "ad-mirror-led-description-" + attribute;
      row.className = "ad-mirror-standard__segments ad-mirror-standard__segments--led";
      row.setAttribute("role", "group");
      row.setAttribute("aria-label", titleText);
      values.forEach(function (value) {
        var button = document.createElement("button");
        var iconNode = document.createElement("span");
        var labelNode = document.createElement("span");
        var imageUrl = ledIconUrl(root, value);
        var active = String(state[attribute] || "") === String(value);
        button.type = "button";
        button.className = "ad-mirror-standard__led-option";
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
        button.setAttribute("aria-label", label(attribute, value) + ". " + ledDescription(value));
        if (active) button.setAttribute("aria-describedby", descriptionId);
        iconNode.className = ledIconClass(value);
        if (imageUrl) {
          var imageNode = document.createElement("img");
          iconNode.className += " is-image";
          imageNode.className = "ad-mirror-standard__led-option-image";
          imageNode.src = imageUrl;
          imageNode.alt = "";
          imageNode.loading = "lazy";
          imageNode.decoding = "async";
          iconNode.appendChild(imageNode);
        }
        iconNode.setAttribute("aria-hidden", "true");
        labelNode.className = "ad-mirror-standard__led-option-title";
        labelNode.textContent = label(attribute, value);
        button.appendChild(iconNode);
        button.appendChild(labelNode);
        button.addEventListener("click", function () {
          state[attribute] = String(value);
          reconcile();
          render();
        });
        row.appendChild(button);
      });
      group.appendChild(row);

      var description = document.createElement("p");
      description.id = descriptionId;
      description.className = "ad-mirror-standard__led-description";
      description.setAttribute("role", "status");
      description.textContent = ledDescription(selectedValue);
      group.appendChild(description);
    }

    function renderReserveSegments(group, attribute, titleText, values) {
      var row = document.createElement("div");
      var selectedValue = String(state[attribute] || values[0] || "");
      var descriptionId = "ad-mirror-mount-description-" + attribute;
      row.className = "ad-mirror-standard__segments ad-mirror-standard__segments--media ad-mirror-standard__segments--mount";
      row.setAttribute("role", "group");
      row.setAttribute("aria-label", titleText);
      values.forEach(function (value) {
        var button = document.createElement("button");
        var iconNode = document.createElement("span");
        var labelNode = document.createElement("span");
        var imageUrl = reserveIconUrl(root, value);
        var active = String(state[attribute] || "") === String(value);
        button.type = "button";
        button.className = "ad-mirror-standard__media-option ad-mirror-standard__mount-option";
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
        button.setAttribute("aria-label", titleText + ": " + label(attribute, value) + ". " + reserveDescription(value));
        if (active) button.setAttribute("aria-describedby", descriptionId);
        iconNode.className = "ad-mirror-standard__media-option-icon ad-mirror-standard__mount-option-icon";
        iconNode.setAttribute("aria-hidden", "true");
        if (imageUrl) {
          var imageNode = document.createElement("img");
          imageNode.className = "ad-mirror-standard__media-option-image";
          imageNode.src = imageUrl;
          imageNode.alt = "";
          imageNode.loading = "lazy";
          imageNode.decoding = "async";
          iconNode.appendChild(imageNode);
        }
        labelNode.className = "ad-mirror-standard__media-option-title";
        labelNode.textContent = label(attribute, value);
        button.appendChild(iconNode);
        button.appendChild(labelNode);
        button.addEventListener("click", function () {
          state[attribute] = String(value);
          reconcile();
          render();
        });
        row.appendChild(button);
      });
      group.appendChild(row);

      var description = document.createElement("p");
      description.id = descriptionId;
      description.className = "ad-mirror-standard__media-description ad-mirror-standard__mount-description";
      description.setAttribute("role", "status");
      description.textContent = reserveDescription(selectedValue);
      group.appendChild(description);
    }

    function renderFrameSwatches(group, attribute, values) {
      group.classList.add("ad-mirror-standard__group--frame");
      var titleText = "Kolor ramy";
      var selectedValue = String(state[attribute] || values[0] || "");
      var selectedSwatch = resolveFrameSwatch(frameSwatches, selectedValue, label(attribute, selectedValue));
      var labelNode = document.createElement("div");
      labelNode.className = "ad-mirror-standard__label ad-mirror-standard__frame-label";
      labelNode.textContent = titleText + ": " + selectedSwatch.label;
      group.appendChild(labelNode);

      var row = document.createElement("div");
      row.className = "ad-mirror-standard__frame-swatches";
      row.setAttribute("role", "radiogroup");
      row.setAttribute("aria-label", titleText);
      values.forEach(function (value) {
        var swatchData = resolveFrameSwatch(frameSwatches, value, label(attribute, value));
        var active = String(state[attribute] || "") === String(value);
        var button = document.createElement("button");
        button.type = "button";
        button.className = "ad-mirror-standard__frame-swatch-button";
        button.classList.toggle("is-active", active);
        button.setAttribute("role", "radio");
        button.setAttribute("aria-checked", active ? "true" : "false");
        button.setAttribute("aria-label", titleText + ": " + swatchData.label);
        button.title = swatchData.label;

        var swatch = document.createElement("span");
        swatch.className = "ad-mirror-standard__frame-swatch";
        swatch.dataset.swatchKind = swatchData.kind || frameSwatchKind(value);
        var swatchImageUrl = swatchData.imageUrl || defaultFrameSwatchImageUrl(root, swatchData.kind || frameSwatchKind(value));
        if (swatchImageUrl) {
          swatch.classList.add("is-image");
          swatch.style.setProperty("--ad-mirror-frame-swatch-image", 'url("' + swatchImageUrl.replace(/"/g, "%22") + '")');
        } else if (swatchData.color) {
          swatch.style.setProperty("--ad-mirror-frame-swatch", swatchData.color);
        }

        var text = document.createElement("span");
        text.className = "ad-mirror-standard__frame-swatch-text";
        text.textContent = swatchData.label;
        button.appendChild(swatch);
        button.appendChild(text);
        button.addEventListener("click", function () {
          state[attribute] = String(value);
          reconcile();
          render();
        });
        row.appendChild(button);
      });
      group.appendChild(row);
    }

    function renderControls() {
      if (!controls) return;
      controls.innerHTML = "";
      VISIBLE_ATTRIBUTES.forEach(function (pair) {
        var attribute = pair[0];
        var titleText = pair[1];
        var values = availableValues(attribute);
        if (values.length <= 1) return;
        var group = document.createElement("div");
        group.className = "ad-mirror-standard__group";
        if (attribute === "frameCode") {
          renderFrameSwatches(group, attribute, values);
        } else if (attribute === "sizeCode") {
          renderSizeSliders(group);
        } else {
          var labelNode = document.createElement("div");
          labelNode.className = "ad-mirror-standard__label";
          labelNode.textContent = titleText;
          group.appendChild(labelNode);
          if (attribute === "ledCode") renderLedSegments(group, attribute, titleText, values);
          else if (attribute === "reserveCode") renderReserveSegments(group, attribute, titleText, values);
          else if (shouldUseSelect(attribute, values)) renderSelect(group, attribute, titleText, values);
          else renderSegments(group, attribute, titleText, values);
        }
        controls.appendChild(group);
      });
      controls.toggleAttribute("hidden", controls.children.length === 0);
    }

    var scheduledRender = 0;
    function scheduleRender() {
      if (scheduledRender) return;
      var frame = window.requestAnimationFrame || function (callback) { return window.setTimeout(callback, 16); };
      scheduledRender = frame(function () {
        scheduledRender = 0;
        render();
      });
    }

    function render() {
      clearDelayedRangeCommit();
      reconcile();
      var selected = exactMatch() || chooseFirst();
      renderControls();
      if (selected) applyItem(selected);
      renderThumbs(selected);
      hideNativeControls();
      placeBlock();
      placeDetails();
      placeFallbackMedia();
    }

    function usablePayload(payload) {
      return !!(payload && Array.isArray(payload.items) && payload.items.length > 0);
    }

    function readEndpoint(endpoint) {
      if (!endpoint || !window.fetch) return Promise.resolve(null);
      return fetch(endpoint, { headers: { Accept: "application/json" } }).then(function (response) {
        var type = response.headers && response.headers.get ? response.headers.get("content-type") || "" : "";
        if (!response.ok || type.indexOf("application/json") < 0) return null;
        return response.json();
      }).catch(function () {
        return null;
      });
    }

    function applyPayload(payload) {
      if (!usablePayload(payload)) return false;
      var contentBySku = {};
      var contentByProduct = {};
      items.forEach(function (item) {
        if (item.productContent) {
          contentBySku[item.sku32] = item.productContent;
          if (item.productGid) contentByProduct[item.productGid] = item.productContent;
        }
      });
      items = payload.items.map(function (item) {
        var sku = String(item.sku32 || "").toUpperCase();
        var productGid = item.productGid || "";
        if (!item.productContent && (contentBySku[sku] || contentByProduct[productGid])) {
          item.productContent = contentBySku[sku] || contentByProduct[productGid];
        }
        return enrich(item, root);
      }).filter(function (item) {
        return item.variantId && item.sku32;
      });
      return items.length > 0;
    }

    function load() {
      var endpoint = root.dataset.endpoint;
      var useFallback = function () {
        if (items.length === 0) {
          if (notice) notice.textContent = "Brak połączonych produktów SKU32 w tej grupie.";
          if (submit) submit.disabled = true;
          return;
        }
        setInitialState();
        render();
      };
      if (!endpoint || !window.fetch) {
        useFallback();
        return;
      }
      readEndpoint(endpoint).then(function (payload) {
        applyPayload(payload);
        useFallback();
      }).catch(useFallback);
    }

    if (form) {
      form.addEventListener("submit", function (event) {
        var selected = exactMatch();
        if (!selected || !selected.variantId) event.preventDefault();
      });
    }
    if (link) link.addEventListener("click", scrollToProductMedia);
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        placeBlock();
        placeDetails();
        placeFallbackMedia();
        hideNativeControls();
      }, { once: true });
    } else {
      placeBlock();
      placeDetails();
      placeFallbackMedia();
      hideNativeControls();
    }
    window.setTimeout(function () { placeBlock(); placeDetails(); placeFallbackMedia(); hideNativeControls(); }, 400);
    window.setTimeout(function () { placeBlock(); placeDetails(); placeFallbackMedia(); hideNativeControls(); }, 1000);
    load();
  }

  function start() {
    document.querySelectorAll("[data-ad-mirror-standard]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, { once: true });
  else start();
})();
